import React from 'react';
import { RadioSelect } from '@keen.io/ui-core';
import { useTranslation } from 'react-i18next';
import Label from '../../../../../Label';
import Row from '../../../../../Row';
import { RadioSelectContainer } from './IconStyle.styles';
import { ICON_STYLE_OPTIONS } from './constants';

var IconStyle = function IconStyle(_ref) {
  var onChange = _ref.onChange,
      iconStyle = _ref.iconStyle;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return React.createElement("div", null, React.createElement(Row, {
    "data-testid": "icon-style"
  }, React.createElement(Label, null, t('widget_customization_metric_settings.icon_style')), React.createElement(RadioSelectContainer, null, React.createElement(RadioSelect, {
    activeItem: iconStyle ? iconStyle : ICON_STYLE_OPTIONS[0].value,
    items: ICON_STYLE_OPTIONS,
    onClick: function onClick(_ref2) {
      var value = _ref2.value;
      return onChange(value);
    }
  }))));
};

export default IconStyle;